import { gql } from '@apollo/client';

export const CREATE_VIRTUAL_DIVISION = gql(/* GraphQL */ `
    mutation CreateVirtualDivision($input: CreateVirtualDivisionInput!) {
        createVirtualDivision(input: $input) {
            id
            name
        }
    }
`);

export const UPDATE_VIRTUAL_DIVISION = gql(/* GraphQL */ `
    mutation UpdateVirtualDivision(
        $id: ID!
        $input: UpdateVirtualDivisionInput!
    ) {
        updateVirtualDivision(id: $id, input: $input) {
            id
            name
        }
    }
`);

export const DELETE_VIRTUAL_DIVISION = gql(/* GraphQL */ `
    mutation DeleteVirtualDivision($id: ID!) {
        deleteVirtualDivision(id: $id)
    }
`);
